import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function formatDate( dt, pretty = true, locale = "en-US" ) {
  // if (!dt) return "";
  // const d = new Date(dt);
  // return d.toLocaleDateString("en-US", {
  //   month: "short",
  //   day: "numeric",
  //   year: "numeric",
  // });
  // above is code was before used will remove once all testing is done
  if (dt == null || dt === "") return "";
  const iso = typeof dt === "string"
    ? dt
    : (dt instanceof Date ? dt.toISOString() : new Date(dt).toISOString());
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return "";
  const [, y, mo, da] = m;
  if (!pretty) return `${y}-${mo}-${da}`;
  const d = new Date(Date.UTC(+y, +mo - 1, +da));
  return new Intl.DateTimeFormat(locale, { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }).format(d);
}

export default function CardSection({
  apiUrl,
  tabLabel,
  page = 1,
  rows = 9,
  onTotal,
}) {
  const { t, ready } = useTranslation();

  if (!ready) {
    return <div>Loading translations...</div>;
  }
  const rawSections = t("newsroom_sections", { returnObjects: true });
  const i18nSections =
    Array.isArray(rawSections) && rawSections.length
      ? rawSections
      : [
          { id: "overview", label: "Overview", href: "/company/newsroom" },
          {
            id: "press",
            label: "Press Releases",
            href: "/company/newsroom/press-releases",
          },
          {
            id: "media",
            label: "Media Kits",
            href: "/company/newsroom/media-kits",
          },
          { id: "events", label: "Events", href: "/company/newsroom/events" },
          { id: "blogs", label: "Blogs", href: "/company/newsroom/blogs" },
        ];

  function stripLocale(pathname) {
    return pathname.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i, "") || "/";
  }

  const activeLabel = (() => {
    const raw = typeof window !== "undefined" ? window.location.pathname : "";
    const path = stripLocale(raw);
    const exact = i18nSections.find(
      (s) => path === s.href || path === `${s.href}/`
    );
    if (exact) return exact.label;
    const match = i18nSections.find(
      (s) => s.href !== "/company/newsroom" && path.startsWith(s.href)
    );
    return match?.label || tabLabel || t("newsroom", "Newsroom");
  })();

  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [docs, setDocs] = useState([]);
  const [facets, setFacets] = useState({ year: [], topics: [], brands: [] });
  const [filters, setFilters] = useState({
    year: [],
    topics: [],
    brands: [],
    yearMonth: [],
  });
  const [didFilterAction, setDidFilterAction] = useState(false);
  const [selectedYM, setSelectedYM] = useState("");
  const [ymIndex, setYmIndex] = useState({ all: [], byYear: {} });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.setNewsroomYM = (ym) => {
        setSelectedYM(ym || "");
        setDidFilterAction(true);
      };
    }
  }, []);

  const hasAnyFilter =
    (filters.year?.length || 0) +
      (filters.topics?.length || 0) +
      (filters.brands?.length || 0) +
      (filters.yearMonth?.length || 0) >
    0;

  function clearAllFilters() {
    setFilters({ year: [], topics: [], brands: [], yearMonth: [] });
    setSelectedYM("");
    setDidFilterAction(false);
    if (typeof window !== "undefined") {
      const url = new URL(window.location.href);
      url.searchParams.delete("page");
      window.history.pushState({}, "", url);
      window.dispatchEvent(new PopStateEvent("popstate"));
      const a = document.getElementById("newsroom-top");
      if (a) a.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function pickYearMonth(nextFilters) {
    if (nextFilters.year?.length) {
      const years = nextFilters.year.map(String);
      const latestYear = years.sort((a, b) => b.localeCompare(a))[0];
      const list = ymIndex.byYear[latestYear] || [];
      if (list.length) return list[0];
    }
    if (ymIndex.all.length) return ymIndex.all[0];
    return "";
  }

  useEffect(() => {
    setLoading(true);
    const fqParts = [];
    if (filters.topics.length) {
      const joined = filters.topics.map(encodeURIComponent).join(",");
      fqParts.push(`cqTagsName_s:${joined}`);
    }
    if (filters.brands.length) {
      const parts = filters.brands.map(
        (b) => `brands:${encodeURIComponent(b)}`
      );
      fqParts.push(`(${parts.join(" OR ")})`);
    }
    if (filters.yearMonth?.length) {
      const ymJoined = filters.yearMonth.map(encodeURIComponent).join(",");
      fqParts.push(`yearMonth:${ymJoined}`);
    }
    const fq = fqParts.map((x) => `&fq=${x}`).join("");
    const start = (page - 1) * rows;
    const url = `${(apiUrl || "").trim()}&rows=${rows}&from=${start}${fq}`;

    if (typeof window !== "undefined") {
      console.debug("[Newsroom] URL =>", JSON.stringify(url));
    }
    if (typeof window !== "undefined") {
      console.debug("[Newsroom] URL =>", url);
    }

    fetch(url)
      .then((r) => r.json())
      .then((json) => {
        const incomingTotal =
          json?.total ??
          json?.totalCount ??
          json?.pagination?.total ??
          json?.meta?.total ??
          json?.response?.numFound ??
          json?.numFound ??
          0;

        onTotal && onTotal(incomingTotal);
        setTotal(incomingTotal);

        const items = json?.docs ?? json?.response?.docs ?? [];
        setDocs(items);
        if ((facets.year?.length ?? 0) === 0 && json?.facet_fields) {
          const ff = json.facet_fields;
          const yearObj = ff.find((f) => f.yearMonth);
          let years = [];
          let ymAll = [];
          let byYear = {};
          if (yearObj?.yearMonth) {
            ymAll = yearObj.yearMonth
              .map((item) => item?.docType)
              .filter(Boolean);
            ymAll.sort((a, b) => b.localeCompare(a));
            const ySet = new Set();
            byYear = {};
            for (const ym of ymAll) {
              const y = ym.slice(0, 4);
              ySet.add(y);
              if (!byYear[y]) byYear[y] = [];
              byYear[y].push(ym);
            }
            years = Array.from(ySet).sort((a, b) => b.localeCompare(a));
          }
          const knownBrands = [
            "Western Digital",
            "WD",
            "WD_Black",
            "SanDisk",
            "SanDisk Professional",
            "G-Technology",
          ].map((b) => b.toLowerCase());
          let topics = [];
          let brands = [];
          const topicsObj = ff.find((f) => f.cqTagsName_s);
          if (topicsObj?.cqTagsName_s) {
            topicsObj.cqTagsName_s.forEach((item) => {
              const type = item.docType?.trim();
              if (!type || type.toLowerCase() === "null") return; // skip empty

              if (knownBrands.includes(type.toLowerCase())) {
                brands.push(type);
              } else {
                topics.push(type);
              }
            });
          }
          setFacets({ year: years, topics, brands });
          setYmIndex({ all: ymAll, byYear });
        }
      })
      .finally(() => setLoading(false));
  }, [
    apiUrl,
    page,
    rows,
    JSON.stringify(filters),
    didFilterAction,
    selectedYM,
  ]);

  function handleFilter(type, value) {
    setDocs([]);
    setLoading(true);
    setFilters((prev) => {
      const next = { ...prev };
      next[type] = next[type].includes(value)
        ? next[type].filter((v) => v !== value)
        : [...next[type], value];

      if (type === "year") {
        const ymSet = new Set();
        next.year.map(String).forEach((y) => {
          (ymIndex.byYear[y] || []).forEach((ym) => ymSet.add(ym));
        });
        next.yearMonth = Array.from(ymSet).sort((a, b) => b.localeCompare(a));
      }

      const anyActive =
        (next.year?.length || 0) +
          (next.topics?.length || 0) +
          (next.brands?.length || 0) +
          (next.yearMonth?.length || 0) >
        0;

      setDidFilterAction(anyActive);

      if (!anyActive) {
        setSelectedYM("");
      } else if (next.yearMonth?.length) {
        setSelectedYM("");
      } else {
        const ym = pickYearMonth(next);
        if (ym) setSelectedYM(ym);
      }

      if (typeof window !== "undefined") {
        const url = new URL(window.location.href);
        url.searchParams.delete("page");
        window.history.pushState({}, "", url);
        window.dispatchEvent(new PopStateEvent("popstate"));
      }

      return next;
    });
  }
  return (
    <div className="card-section">
      <section className="section relative py-12">
        <div className="relative contain-fluid mx-auto">
          <div className="row grid-12 xs:grid-12 sm:grid-12 md:grid-12 lg:grid-12 xl:grid-12 flex-wrap md:flex flex">
            <div className="cols-12 md:cols-12">
              <div className="grid-12 md:grid-12 flex flex-wrap">
                <div className="cols-12 md:cols-3 md:pr-4">
                  <div className="md:relative fixed z-30 md:z-auto pin-t w-full h-full overflow-auto pin-l bg-white px-8 md:px-0 nrFilterWrap hidden md:block">
                    <div className="fixed md:relative bg-white w-full pr-16 md:pr-0 z-1">
                      <div className="border-b border-t border-grey-light mb-5 md:mt-12 py-4 flex justify-between items-center">
                        <h6 className="text-black m-0 text-base">
                          {t("filterBy")}
                        </h6>
                        {hasAnyFilter && (
                          <button
                            type="button"
                            onClick={clearAllFilters}
                            className="text-sm underline hover:opacity-80 focus:outline-none"
                          >
                            {t("resource.clear_all")}
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="relative mt-20 md:mt-0">
                      {facets.year && facets.year.length > 0 && (
                        <div>
                          <div className="border-b border-grey-light mb-4 pb-2">
                            <div className="mb-5 flex items-center">
                              <h4 className="font-bold text-base mb-0">
                                {t("newsroom_ui.date")}
                              </h4>
                            </div>
                            {facets.year.map((year) => (
                              <div className="relative mb-2" key={year}>
                                <label className="checkbox flex items-center text-base ml-1">
                                  <span className="ml-3 flex sm:block">
                                    {year}
                                  </span>
                                  <input
                                    type="checkbox"
                                    checked={filters.year.includes(year)}
                                    onChange={() => handleFilter("year", year)}
                                  />
                                  <span className="checkmark sm:mt-1"></span>
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {facets.brands && facets.brands.length > 0 && (
                        <div>
                          <div className="border-b border-grey-light mb-4 pb-2">
                            <div className="mb-5 flex items-center">
                              <h4 className="font-bold text-base mb-0">
                                {t("newsroom_ui.brands")}
                              </h4>
                            </div>
                            {facets.brands.map((brand) => (
                              <div className="relative mb-2" key={brand}>
                                <label className="checkbox flex items-center text-base ml-1">
                                  <span className="ml-3 flex sm:block">
                                    {brand}
                                  </span>
                                  <input
                                    type="checkbox"
                                    checked={filters?.topic?.includes(brand)}
                                    onChange={() =>
                                      handleFilter("topics", brand)
                                    }
                                  />
                                  <span className="checkmark sm:mt-1"></span>
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {facets.topics && facets.topics.length > 0 && (
                        <div>
                          <div className="border-b border-grey-light mb-4 pb-2">
                            <div className="mb-5 flex items-center">
                              <h4 className="font-bold text-base mb-0">
                                {t("newsroom_ui.topics")}
                              </h4>
                            </div>
                            {facets.topics.map((topic) => (
                              <div className="relative mb-2" key={topic}>
                                <label className="checkbox flex items-center text-base ml-1">
                                  <span className="ml-3 flex sm:block">
                                    {topic}
                                  </span>
                                  <input
                                    type="checkbox"
                                    checked={filters.topics.includes(topic)}
                                    onChange={() =>
                                      handleFilter("topics", topic)
                                    }
                                  />
                                  <span className="checkmark sm:mt-1"></span>
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="cols-12 md:cols-9 md:pl-4">
                  <h5 className="mb-6">{activeLabel}</h5>

                  {loading ? (
                    <div className="text-center my-12 text-lg">Loading...</div>
                  ) : (
                    <div className="grid-12 sm:grid-12 md:grid-12 sm:flex flex-wrap sm:-mx-2">
                      {docs.map((d, idx) => (
                        <div
                          key={d.url || idx}
                          className="cols-12 sm:cols-6 md:cols-4 sm:px-2 mb-4 nrTile"
                        >
                          <div className="bg-grey-1 h-full">
                            <div className="nrImgThumb relative">
                              {tabLabel == "Media Kits" &&
                                !(idx === 0 && page === 1) && (
                                  <>
                                    <div class="imgBadge absolute pin-l">
                                      <img src="https://www.westerndigital.com/content/dam/western-digital/en-us/portal-assets/icons/zip.png" />
                                    </div>
                                  </>
                                )}
                              <div
                                className="responsive-image"
                                style={{
                                  backgroundImage: `url(${d.primaryImage})`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  borderRadius: "4px",
                                }}
                              >
                                {idx === 0 && page === 1 && (
                                  <span className="bg-black text-white py-1 px-4 text-xs font-medium absolute right-0 top-0">
                                    {t("newsroom_ui.new_badge")}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="bg-grey-1 p-6">
                              <div className="text-xs mb-1 leading-tight">
                                <span className="uppercase nrDataTag">
                                  {activeLabel}
                                </span>
                              </div>
                              <div
                                className="text-bold text-lg leading-tight nrDataTitle inline-block mb-2"
                                style={{
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  textOverflow: "ellipsis",
                                  maxHeight: "3em",
                                }}
                              >
                                {d.title}
                              </div>
                              <div
                                className="text-sm leading-tight inline-block mb-4"
                                style={{
                                  display: "-webkit-box",
                                  WebkitLineClamp: 4,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxHeight: "5em",
                                }}
                              >
                                {d?.description}
                              </div>
                              {tabLabel == "Events" ? (
                                <div className="text-xs mb-4 uppercase">
                                  {formatDate(d?.eventStartDate)} {" - "}{" "}
                                  {formatDate(d?.eventEndDate) || ""}
                                </div>
                              ) : tabLabel == "Blogs" ? (
                                <div className="text-xs mb-4 uppercase">
                                  {formatDate(d?.documentTypeDate[0])}
                                </div>
                              ) : (
                                <div className="text-xs mb-4 uppercase">
                                  {formatDate(d?.documentTypeDate)}
                                </div>
                              )}
                              <div className="text-sm underline">
                                {tabLabel == "Media Kits" ? (
                                  <a
                                    target="_self"
                                    href={d.url}
                                    className="block"
                                  >
                                    {t("resource.download")}
                                  </a>
                                ) : (
                                  <a
                                    target="_self"
                                    href={d.url}
                                    className="block"
                                  >
                                    {t("newsroom_ui.read_more")}
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      {docs.length === 0 && (
                        <div className="w-full text-center py-12 text-lg">
                          {t("resource.no_results_found")}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
